<template>
  <div class="scholarship-wrap pt-2">
    <b-container>
      <NavFilter
        :clzLayout="useApp.layout"
        :pSearch="pSearch"
        @onLayoutChange="useApp.onLayoutChange"
        @onSearch="onSearch"
        @onApply="onApply"
      />
      <div class="text-right pb-2" v-if="allData && allData.length > 0">
        <span class="lb-result">{{ totalSupply }} results</span>
      </div>
      <div v-if="isLoadData" class="item-list">
        <div
          v-for="k in $_.range(0, useApp.layout === 'columns-4' ? 8 : 6)"
          :key="`skelton-${k}`"
          :class="useApp.layout"
        >
          <CardSaruSkeleton />
        </div>
      </div>
      <div v-else class="item-list">
        <div v-for="item in listItems" :key="item.name" :class="useApp.layout">
          <card-saru :info="item" :tokenId="item.id" />
        </div>
        <div v-if="loadingItems && 1 < page" class="text-center pb-3 pt-3">
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import NavFilter from "./NavFilter.vue";
import saruData from "@/assets/kuni-saru-stats.json";
import { Scholarship, NFT } from "@/amakunicom/sdk";
import { keyBy, includes, filter, lowerCase } from "lodash";
import CardSaru from "./CardSaru.vue";
import { ethers } from "ethers";
import CardSaruSkeleton from "./CardSaruSkeleton.vue";
import { useAppStore } from "@/uses";

const objData = keyBy(saruData.data, "id");

export default {
  name: "Scholarship",
  data: () => ({
    isLoadData: true,
    allData: [],
    page: 1,
    limit: 12,
    totalSupply: 0,
    listItems: [],
    loadingItems: true,
    loadingData: true,
    pSearch: {
      search: "",
      selected: "rate",
      orSelected: "H2L",
    },
  }),
  setup() {
    const useApp = useAppStore();
    console.log(useApp.layout);
    return { useApp };
  },
  components: { NavFilter, CardSaru, CardSaruSkeleton },
  updated: async function () {
    this.$nextTick().then(() => {
      setTimeout(() => {
        let nftImg = document.querySelector(".nft-item");
        if (nftImg) {
          if (nftImg.naturalWidth < 200) {
            this.isPixelated = true;
          } else {
            this.isPixelated = false;
          }
        }
      }, 5000);
    });
    console.log("updated.....");
  },
  created() {
    console.log("created.....");
    this.tokens = this.getCoreConfig();
    this.chainId = this.tokens.chainId;
    this.initData();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    async initData() {
      this.signer = await this.provider.getSigner();
      this.account = await this.signer.getAddress();
      this.cNft = await NFT.initWith(this.tokens.kuniSaru, this.provider);
      this.scholar = await Scholarship.initWith(
        this.tokens.scholarship,
        this.provider,
        this.signer
      );
      await this.loadData();
      if (!this.timer) {
        this.timer = setInterval(this.loadData, 20000);
      }
    },
    async onApply(params) {
      this.pSearch = params;
      await this.loadData();
      this.loadingData = false;
    },
    async loadData() {
      try {
        let myAddr = this.tokens.scholarship;
        let mySupply = 0;
        let myList = [];
        if (this.pSearch.myType === "yourNft") {
          myAddr = this.account;
          [mySupply, myList] = await this.cNft.toNftScholar(myAddr);
        }
        this.totalSupply = await this.scholar.balanceOf(
          this.tokens.kuniSaru,
          myAddr
        );
        this.totalSupply = Number(mySupply) + Number(this.totalSupply);
        const rs = await this.scholar.nftBy(this.tokens.kuniSaru, myAddr, true);
        this.allData = [...myList, ...rs.data].map(
          ({ tokenId, rate, owner }) => ({
            ...objData[`${Number(tokenId)}`],
            rate,
            owner,
          })
        );
        this.allData = [...this.allData];
        this.onSearch();
      } catch (error) {
        console.log("looi===> ", error);
      }
    },
    async handleScroll() {
      let d = document.documentElement;
      let offsetHeight = window.innerHeight;
      let offset = d.scrollTop + offsetHeight;
      let height = d.scrollHeight;
      let delta = 10;
      //   let total =
      //     this.allData.length > 0 ? this.listItems.length : this.totalSupply;
      if (
        offset + delta >= height &&
        this.page * this.limit < this.totalSupply
      ) {
        this.page = this.page + 1;
        this.loadingItems = true;
        await this.onSearch();
        this.loadingItems = false;
      }
    },
    async onSearch(params) {
      if (params) {
        this.pSearch = params;
      }
      let result = [...this.allData];
      this.utils.sortByProp(
        result,
        this.pSearch.selected,
        this.pSearch.orSelected === "H2L"
      );
      let textSearch = this.pSearch.search;
      if (textSearch) {
        textSearch = `${textSearch}`.toLocaleLowerCase();
        if (ethers.utils.isAddress(textSearch)) {
          result = filter(
            result,
            ({ name, id }) =>
              includes(lowerCase(name), textSearch) || includes(id, textSearch)
          );
        } else {
          if (textSearch.startsWith("#")) {
            result = filter(result, ({ id }) => `#${id}` === textSearch);
          } else {
            result = filter(
              result,
              ({ name, id }) =>
                includes(lowerCase(name), textSearch) ||
                includes(id, textSearch)
            );
          }
        }
      }
      await new Promise((r) => setTimeout(r, 2000));
      this.listItems = result.slice(0, this.page * this.limit);
      this.isLoadData = false;
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.scholarship-wrap {
  .lb-result {
    padding: 4px 16px;
    border-radius: 5px;
    background-image: linear-gradient(to top, #503161, rgba(70, 50, 100, 0)),
      linear-gradient(to bottom, #eb345f, #eb345f);
    font-size: 12px;
    color: #fff;
  }
  .item-list {
    padding: 16px 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
    .columns-4 {
      width: calc(25% - 16px);
      .nft-item {
        width: 100%;
      }
    }
    .columns-3 {
      width: calc(33.33% - 16px);
      .nft-item {
        width: 100%;
      }
    }
  }
  @media (max-width: 767px) {
    .item-list {
      flex-direction: column;
      .columns-4,
      .columns-3 {
        width: 100% !important;
        .card {
          &.nft-item {
            width: 100% !important;
          }
        }
      }
    }
  }

  @media (max-width: 560px) {
    .item-list {
      flex-direction: column;
      .columns-4,
      .columns-3 {
        width: 100% !important;
        .card {
          &.nft-item {
            width: 100% !important;
          }
        }
      }
    }
  }
}
</style>
